import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function Tablet(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.693 1c1.156 0 2.096.94 2.096 2.097v17.654c0 1.156-.94 2.097-2.096 2.097H5.097A2.1 2.1 0 013 20.751V3.097A2.1 2.1 0 015.097 1h14.596zm.095 17.242H4.999L5 20.751c0 .054.044.097.097.097h14.596a.096.096 0 00.096-.097l-.001-2.509zm-7.43.33a1 1 0 11-.001 2.001 1 1 0 010-2zm7.43-12.353H4.999v10.023h14.789V6.219zM19.693 3H5.097A.097.097 0 005 3.097l-.001 1.122h14.789l.001-1.122A.096.096 0 0019.693 3z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoTablet = React.memo(Tablet);
export default MemoTablet;